import React from "react";
import { Sheet } from "../jigyasa/sheets";
import { ListOrdered, Tag, MapPin, XCircle, ChevronRight } from "lucide-react";

// "How your enquiries flow" — the single, plain-English settings screen a Solo
// owner sees instead of the five separate technical editors. It groups the
// follow-up steps, products, sources and lost-reasons behind friendly labels
// and simply opens the existing (fully tested) editor drawers on top. No
// jargon, no "Lines of business" — a one-person business never needs that.
const Row = ({ icon: Icon, label, desc, onClick, testId }) => (
  <button
    type="button"
    data-testid={testId}
    data-tour-id={testId}
    onClick={onClick}
    className="flex w-full items-center gap-3 rounded-xl border border-zinc-200 bg-white px-4 py-3.5 text-left transition-colors hover:bg-zinc-50"
  >
    <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-zinc-100 text-zinc-600">
      <Icon size={17} />
    </span>
    <span className="min-w-0 flex-1">
      <span className="block text-[15px] font-medium text-zinc-900">{label}</span>
      <span className="block text-xs text-zinc-500">{desc}</span>
    </span>
    <ChevronRight size={18} className="shrink-0 text-zinc-300" />
  </button>
);

export const EnquiryFlowSheet = ({
  open,
  onClose,
  onOpenStatuses,
  onOpenTypes,
  onOpenSources,
  onOpenLost,
}) => (
  <Sheet open={open} onClose={onClose} testId="enquiry-flow-sheet" title="How your enquiries flow">
    <p className="mb-4 text-sm text-zinc-500">
      These were set up for you when you started. Open one only if you'd like to change it.
    </p>
    <div className="space-y-2.5">
      <Row
        testId="flow-steps"
        icon={ListOrdered}
        label="Follow-up steps"
        desc="The steps a lead moves through"
        onClick={onOpenStatuses}
      />
      <Row
        testId="flow-types"
        icon={Tag}
        label="What do people ask you for?"
        desc="Your products or services"
        onClick={onOpenTypes}
      />
      <Row
        testId="flow-sources"
        icon={MapPin}
        label="Where do people find you?"
        desc="Walk-in, phone, referral…"
        onClick={onOpenSources}
      />
      <Row
        testId="flow-lost"
        icon={XCircle}
        label="Why we lose deals"
        desc="Reasons a deal didn't work out"
        onClick={onOpenLost}
      />
    </div>
  </Sheet>
);
